/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
    CATEGORY_TYPE,
    ETK_CESAR,
    IS_NEXT_IN_LIST,
    ISCHEAPEST,
    ISEXPENSIVE,
    ITEM_TYPE,
    STEP_TYPE,
} from "@constants";
import { merge } from "lodash";

import { refactorAdvancedDisplay } from "./Helpers";
import { kioskVisibilityRefactor } from "./workfolw";

export function getRedirectItemsStep(globalcard: any, iuudMD5: string) {
    let stepListProduct: any[] = [];
    let displayTitle: any = {};
    let linkedCategorieUuid = "";
    let design = {};
    globalcard.modifier[iuudMD5]?.steps &&
        Object.entries(globalcard.modifier[iuudMD5]?.steps)
            .sort((a: any, b: any) => a[1].rank - b[1].rank)
            .forEach(([iuudStep]) => {
                const isOverridedStep =
                    globalcard.modifier[iuudMD5]?.steps[iuudStep]?.ovr &&
                    Object.keys(
                        globalcard.modifier[iuudMD5]?.steps[iuudStep].ovr
                    ).length > 0;

                let currentStep = globalcard?.steps?.[iuudStep];

                if (isOverridedStep) {
                    currentStep = merge(
                        {},
                        globalcard?.steps?.[iuudStep],
                        globalcard.modifier[iuudMD5]?.steps[iuudStep].ovr
                    );
                    const overriddenStepItems = Object.keys(
                        currentStep.stepItems
                    ).reduce((prev, curr) => {
                        return {
                            ...prev,
                            [curr]: {
                                ...globalcard?.steps?.[iuudStep].stepItems[
                                    curr
                                ],
                                ...currentStep.stepItems[curr],
                            },
                        };
                    }, {});
                    currentStep.stepItems = overriddenStepItems;
                }

                displayTitle = {
                    isVisible: true,
                    content:
                        currentStep.displayName.dflt.nameDef !== ""
                            ? currentStep.displayName.dflt.nameDef
                            : currentStep.title,
                    advancedDisplayName: refactorAdvancedDisplay(
                        currentStep.displayName
                    ),
                };
                design = globalcard.modifier[iuudMD5]?.steps[iuudStep]?.design
                    ? globalcard.modifier[iuudMD5]?.steps[iuudStep]?.design
                    : {};

                //! si reference contient etoile on renvoie id
                if (currentStep?.ref?.startsWith("*")) {
                    Object.keys(globalcard.categories).forEach((key) => {
                        if (
                            globalcard.categories[key]?.ref ===
                            currentStep.ref.substring(1)
                        ) {
                            linkedCategorieUuid = key;
                            return true;
                        }
                    });
                }

                // get list uuid items in step
                stepListProduct = getlistitems(
                    iuudStep,
                    iuudMD5,
                    STEP_TYPE,
                    currentStep,
                    globalcard
                );
            });
    return { stepListProduct, displayTitle, linkedCategorieUuid, design };
}

export function getlistitems(
    iuudStep: any,
    iuudMD5: any,
    typeModifier: string,
    currentStep: any,
    globalcard: any
) {
    //   let listItems: any[] = [];

    return Object.entries(currentStep?.stepItems)
        .sort((a: any, b: any) => a[1].rank - b[1].rank)
        .filter(
            ([iuud]) =>
                !globalcard.items?.[iuud] ||
                globalcard.items?.[iuud].archive === false
        )
        .map(([iuud]) => {
            /// product is modifier

            const modifier = globalcard.modifier[iuudMD5][typeModifier][
                iuudStep
            ].items[iuud]
                ? globalcard.modifier[iuudMD5][typeModifier][iuudStep].items[
                      iuud
                  ]
                : "";
            const productType =
                globalcard.items?.[iuud].isRedirect &&
                (globalcard.items?.[iuud].offer === undefined ||
                    !globalcard.items?.[iuud].offer.isEnabled)
                    ? CATEGORY_TYPE
                    : ITEM_TYPE;
            const messageBasicComposition = currentStep.stepItems[iuud]
                .msgBasicComp
                ? currentStep.stepItems[iuud].msgBasicComp
                : [];
            const isHiddenBasicComp =
                !globalcard?.showBc ||
                !(globalcard.items[iuud].showBc ?? true) ||
                !(currentStep?.stepItems[iuud]?.isVisiblebasicComp ?? true);
            return {
                ...globalcard.items?.[iuud],
                iuud: iuud,
                type: productType,
                isStepItem: false,
                maxNbrOfChoicesInStep: currentStep?.stepItems[iuud].maxChoices,
                minNbrOfChoicesInStep: currentStep?.stepItems[iuud].minChoices,
                nbrOfChoicesWithspecialPrice:
                    currentStep?.stepItems[iuud].nbrWithspecialPrice,
                nbrOfChoicesWithStepPrice:
                    currentStep?.stepItems[iuud].nbrWithPrice,
                color: currentStep?.stepItems[iuud].color,
                fidelity:
                    globalcard?.cardType === ETK_CESAR ||
                    globalcard?.cardType === undefined
                        ? globalcard.items?.[iuud].fid
                        : currentStep?.stepItems[iuud].fid,
                specialPrice: currentStep?.stepItems[iuud].specialPrice,
                priceOfItemInStep: currentStep?.stepItems[iuud].priceStep,
                modifier,
                StepPriceRule: currentStep.specificOpts.isNext
                    ? IS_NEXT_IN_LIST
                    : currentStep.specificOpts.isCheapest
                    ? ISCHEAPEST
                    : currentStep.specificOpts.isExpensive
                    ? ISEXPENSIVE
                    : ISCHEAPEST,
                hidePrice: !currentStep?.specificOpts.zeroPrice,

                haveWorkflow:
                    globalcard.modifier[modifier]?.steps &&
                    Object.keys(globalcard.modifier[modifier]?.steps).length > 0
                        ? true
                        : false,

                haveAdditionalSale:
                    globalcard.modifier[modifier]?.add &&
                    Object.keys(globalcard.modifier[modifier]?.add).length > 0
                        ? true
                        : false,

                stepTitle: currentStep.title,
                visibilityInfo: currentStep?.stepItems[iuud].visibilityInfo,
                KioskVisibility: kioskVisibilityRefactor(
                    currentStep?.stepItems[iuud].visibilityInfo.isVisible,
                    currentStep?.stepItems[iuud].visibilityInfo.dflt
                ),
                haveComment:
                    globalcard.items?.[iuud].isComment === true
                        ? globalcard.items?.[iuud].isComment
                        : false,
                redirection: true,
                isHiddenBasicComp,
                messageBasicComposition,
            };
        });
}

export function getRefactoredSalesModes(saleMode: any) {
    let language = "";
    switch (saleMode) {
        case "0":
            language = "all";
            break;
        case "1":
            language = "En livraison";
            break;
        case "2":
            language = "Emporter";
            break;
        case "3":
            language = "Sur place";
            break;
        case "4":
            language = "Restaurant";
            break;
        case "5":
            language = "Drive";
            break;
        case "6":
            language = "Retrait C&C";
            break;
        default:
            language = "";
    }
    return language;
}

export function getListItemsStep(globalcard: any, iuudMD5: string) {
    let stepListProduct: any[] = [];
    let displayTitle: any = {};
    let linkedCategorieUuid = "";
    let design = {};
    globalcard.modifier[iuudMD5]?.steps &&
        Object.entries(globalcard.modifier[iuudMD5]?.steps)
            .sort((a: any, b: any) => a[1].rank - b[1].rank)
            .forEach(([iuudStep]) => {
                let currentStep = globalcard?.steps?.[iuudStep];
                currentStep = merge(
                    {},
                    globalcard?.steps?.[iuudStep],
                    globalcard.modifier[iuudMD5]?.steps[iuudStep].ovr
                );
                const overriddenStepItems = Object.keys(
                    currentStep.stepItems
                ).reduce((prev, curr) => {
                    if (!globalcard?.items[curr]) return { ...prev };
                    return {
                        ...prev,
                        [curr]: {
                            ...globalcard?.items[curr],
                            ...globalcard?.steps?.[iuudStep].stepItems[curr],
                            ...currentStep.stepItems[curr],
                        },
                    };
                }, {});
                currentStep.stepItems = overriddenStepItems;

                displayTitle = {
                    isVisible: true,
                    content:
                        currentStep.displayName.dflt.nameDef !== ""
                            ? currentStep.displayName.dflt.nameDef
                            : currentStep.title,
                    advancedDisplayName: refactorAdvancedDisplay(
                        currentStep.displayName
                    ),
                };
                design = globalcard.modifier[iuudMD5]?.steps[iuudStep]?.design
                    ? globalcard.modifier[iuudMD5]?.steps[iuudStep]?.design
                    : {};

                //! si reference contient etoile on renvoie id
                if (currentStep?.ref?.startsWith("*")) {
                    Object.keys(globalcard.categories).forEach((key) => {
                        if (
                            globalcard.categories[key]?.ref ===
                            currentStep.ref.substring(1)
                        ) {
                            linkedCategorieUuid = key;
                            return true;
                        }
                    });
                }

                // get list uuid items in step
                stepListProduct = getlistitems(
                    iuudStep,
                    iuudMD5,
                    STEP_TYPE,
                    currentStep,
                    globalcard
                );
            });
    return { stepListProduct, displayTitle, linkedCategorieUuid, design };
}
